import { render } from "./points_manage.vue?vue&type=template&id=5edaaa46&scoped=true"
import script from "./points_manage.vue?vue&type=script&lang=js"
export * from "./points_manage.vue?vue&type=script&lang=js"

import "./points_manage.vue?vue&type=style&index=0&id=5edaaa46&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edaaa46"],['__file',"src/views/account_center/components/points_manage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5edaaa46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5edaaa46', __exports__)) {
    api.reload('5edaaa46', __exports__)
  }
  
  module.hot.accept("./points_manage.vue?vue&type=template&id=5edaaa46&scoped=true", () => {
    api.rerender('5edaaa46', render)
  })

}


export default __exports__